import { SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const ProtectionOfDataPrivacyStatement = () => {
  const { classes } = useTOCStyles();

  return (
    <div>
      <SectionHeader title="Protection of Data" />
      <ol type="a" start={5}>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`To safeguard your personal data, all electronic storage and transmission of personal data is ` +
              `secured with appropriate security technologies.`}
          </Typography>
        </li>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            {`This digital service may contain links to non-Government digital services whose data ` +
              `protection and privacy practices may differ from ours. We are not responsible for the content and ` +
              `privacy practices of these other digital services and we encourage ` +
              `you to consult the privacy notices ` +
              `of those digital services.`}
          </Typography>
        </li>
      </ol>
    </div>
  );
};

export default ProtectionOfDataPrivacyStatement;
